import { useEffect, useState } from 'react';
import api from '../components/wrapper/API';

const POLL_INTERVAL_MS = 30_000;

/**
 * Holt regelmäßig den Dead-Letter-Count für den Sidebar-/Home-Badge.
 * `enabled = false` schaltet das Polling komplett ab (z.B. für Nicht-Admins).
 */
export default function useMailQueueBadge({ enabled = true } = {}) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }

    let cancelled = false;

    const fetchCount = async () => {
      try {
        const res = await api.get('/DeadLetterMail/Count', { background: true });
        if (!cancelled) setCount(res.data?.count ?? 0);
      } catch {
        // Stillschweigend ignorieren — der Badge ist UX, kein blocker.
      }
    };

    fetchCount();
    const id = setInterval(fetchCount, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [enabled]);

  return count;
}
